import { Decimal as BigJs } from "decimal.js";

export const PRODUCTION = "production";

export const DEVELOPMENT = "development";

export const MAX_UINT256 = new BigJs(2)
  .pow(256)
  .minus(1)
  .toFixed(0);

export const WALLET_CONNECT = "wallet_connect";

export const METAMASK = "metamask";

export const GET_BUSD_PRICE_URL =
  "https://api.pancakeswap.info/api/v2/tokens/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56";
